import { render, staticRenderFns } from "./TitleHistory.vue?vue&type=template&id=58d22aef&scoped=true&"
import script from "./TitleHistory.vue?vue&type=script&lang=js&"
export * from "./TitleHistory.vue?vue&type=script&lang=js&"
import style0 from "./TitleHistory.vue?vue&type=style&index=0&id=58d22aef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d22aef",
  null
  
)

export default component.exports